<div class="container">
  <qai-simulation-card
    [title]="simulationDetails!.name"
    [callType]="'Knowledge check'"
    [description]="simulationDetails!.description"
    [estimatedTime]="simulationDetails!.callInstructions"
    [showCallDetailsButton]="true"
    [showCallDetailsButtonDisabled]="previewModalButtonState"
    (callDetailsClick)="callDetailsClick($event)"
    [avatarImageSrc]="simulationDetails!.avatarUrl"
  ></qai-simulation-card>
</div>


<preview-simulations-details-modal
  [open]="openPreviewModal"
  [tabs]="previewTabs"
  (closeModal)="handleModalClose()"
></preview-simulations-details-modal>
